import { Button } from '@fluentui/react-components';
import React from 'react';
import styles from './FabricMixinButton.module.scss';
export var FabricMixinButton = function () {
    return (React.createElement(Button, { appearance: "primary", className: styles.button }, "Fabric button"));
};
//# sourceMappingURL=FabricMixinButton.js.map